import React from 'react';

import { getFullTextDate } from '../../lib';

type Props = {
  attribute?: string[] | null;
  title?: string;
};

export const TextAttribute: React.FC<Props> = ({ attribute, title }) => {
  const isDate = title?.toLowerCase().includes('дата') ?? false;

  return (
    <>
      {attribute?.map((value, i) => (
        <div data-id="textAttr" key={i}>
          {isDate ? getFullTextDate(value) : value}
        </div>
      )) ?? null}
    </>
  );
};
